export const DATA = {
  phone: {
    view: "0731 779303",
    call: "+390731779303",
  },
  vat: "02069180426",
  rea: "AN-158762",
  shareCapital: "€ 10.400,00",
  residenceLegalName: "OASI SRL RESIDENCE",
  cin: "IT042049A1KXZ7WOZF",
  name: "Ristorante Oasi Staffolo",
  keywords: [
    "Ristorante Oasi Staffolo",
    "Ristorante Pesce Staffolo",
    "Ristorante Carne Staffolo",
    "Ristorante Staffolo, Oasi Staffolo",
    "cucina marchigiana",
    "carne e pesce Staffolo",
    "pasta fresca artigianale",
    "catering eventi Marche",
    "residence Staffolo",
    "soggiorni Marche",
    "cerimonie Staffolo",
    "ristorante tradizionale Marche",
    "piatti tipici Staffolo",
    "agriturismo Staffolo",
    "camere con comfort Staffolo",
    "cucina genuina",
    "prodotti locali",
  ],
  logo: "https://oasistaffolo.it/logo.png",
  homepage: "https://oasistaffolo.it",
  priceRange: "€€",
  email: "oasi.srl@libero.it",
  legalName: "OASI S.R.L.",
  socials: {
    facebook: "https://www.facebook.com/OasiRistoranteStaffolo",
    instagram: "https://www.instagram.com/ristoranteoasistaffolo/",
    matrimonio:
      "https://www.matrimonio.com/catering-matrimoni/oasi-catering--e115616",
  },
  menuUrl: "https://oasistaffolo.it/menu",
  location: {
    address: "Via Marco Biagi",
    addressNumber: "1",
    city: "Staffolo",
    cap: "60039",
    state: "AN",
    country: "IT",
    latitude: 43.43907058958373,
    longitude: 13.212526671230583,
  },
  dish: {
    type: {
      appetizers: "Antipasti",
      firstCourses: "Primi piatti",
      mainCourses: "Secondi piatti",
      sideDishes: "Contorni",
      pizzeria: "Pizzeria",
      desserts: "Dessert",
      beverages: "Bevande",
      theCellar: "La cantina",
    },
    foodCategories: {
      meat: "Carne",
      fish: "Pesce",
      redPizzas: "Pizze rosse",
      whitePizzas: "Pizze bianche",
      whiteWinesMarche: "Vini bianchi Marche",
      nationalWhiteWines: "Vini bianchi nazionali",
      redWines: "Vini rossi",
      sparklingAndLiqueurWines: "Bollicine e Liquorosi",
      afterMeal: "Fine pasto",
    },
    allergens: {
      cerealsAndDerivatives: "Cereali e derivati",
      crustaceans: "Crostacei",
      eggs: "Uova",
      fish: "Pesce",
      peanuts: "Arachidi",
      soy: "Soia",
      milk: "Latte",
      treeNuts: "Frutta a guscio",
      celery: "Sedano",
      mustard: "Senape",
      sesame: "Sesamo",
      sulfurDioxideAndSulfites: "Anidride solforosa e solfiti",
      lupins: "Lupini",
      mollusks: "Molluschi",
    },
  },
  externalLinks: {
    weddingPlanner: "https://www.lovingmarchewedding.com/",
  },
} as const;
